import React from 'react';
import Navbar from './NavbarUnder';
import Footer from './FooterAtBottom';
export default () => {
   return (
      <div className="thank-you">
         <Navbar />
         <div className="thank-you-wrap">
            <h2>Xin cám ơn!</h2>
            <h2>Uplevo sẽ liên hệ lại sớm để đánh giá Logo của anh chị</h2>
            <h2>Khách hàng cần thiết kế ngay có thể liên hệ trực tiếp theo thông tin sau:</h2>
            <h2>Hotline: 0948100841</h2>
         </div>
         <Footer/>
      </div>
   )
}


// WEBPACK FOOTER //
// ./src/components/App/ThankYou.js